import React from 'react';

export const ChevronDown = () => (
    <polyline points='6 9 12 15 18 9' />
);